
import CheckBoxTwoToneIcon from '@mui/icons-material/CheckBoxTwoTone';
import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone';
import { PendingTwoTone } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

function StatusIcon({ value }) {
	if (value) {
		return (
			<CheckBoxTwoToneIcon color="success" />
		)
	} else {
		return (
			<CancelTwoToneIcon color="error" />
		)
	}
}

function StatusIconRevision({ value }) {
	if (value === "Aprobado") {
		return (
			<Box sx={{ textAlign: "center" }}>
				<Typography variant="subtitle2">Estado</Typography>
				<Typography variant="body1" sx={{ display: "flex", alignItems: "center", justifyContent: "center", mt: 1 }}>
					<CheckBoxTwoToneIcon color="success" />
					Aprobado
				</Typography>
			</Box>
		)
	}
	else if (value === "Rechazado") {
		return (
			<Box sx={{ textAlign: "center" }}>
				<Typography variant="subtitle2">Estado</Typography>
				<Typography variant="body1" sx={{ display: "flex", alignItems: "center", justifyContent: "center", mt: 1 }}>
					<CancelTwoToneIcon color="error" />
					Rechazado
				</Typography>
			</Box>
		)
	}
	else {
		return (
			<Box sx={{ textAlign: "center" }}>
				<Typography variant="subtitle2">Estado</Typography>
				<Typography variant="body1" sx={{ display: "flex", alignItems: "center", justifyContent: "center", mt: 1 }}>
					<PendingTwoTone color="warning" />
					Pendiente de revisión
				</Typography>
			</Box>
		)
	}
}

export { StatusIcon, StatusIconRevision }